import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import voucherSelect from './components/voucherSelect.vue'
import paymentSuccess from './components/paymentSuccess.vue'
import paymentFailed from './components/paymentFailed.vue'
import Terms from './components/Terms.vue'
import adminLogin from './components/admin/adminLogin.vue'
import dateSelect from './components/dateSelect.vue'




Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    { path: '/index.html', 
      component: Home,
      alias: '/'
    }, // Fix for PWA at /index.html
   
    {
      path: '/select',
      name: 'voucherSelect',
      component: voucherSelect
    },
    {
      path: '/payment/success',
      name: 'paymentSuccess',
      component: paymentSuccess
    },
    {
      path: '/payment/failed',
      name: 'paymentFailed',
      component: paymentFailed
    },
    {
      path: '/date/select',
      name: 'dateSelect',
      component: dateSelect
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms
    },
    {
      path: '/admin',
      name: 'Login',
      component: adminLogin
    }
  ]
})
